import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-md-12 text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "row mt-4 mb-3" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "nnavbar fixed-bottom bg-body-tertiary" }
const _hoisted_12 = { class: "container-fluid justify-content-start" }

import { defineComponent, onMounted, reactive } from "vue";
  import { useRoute } from 'vue-router';


  //servicos
  import * as service from "@/services/clienteService";

  //componentes

  import imgLogin from "@/assets/images/logoLogin.png";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'VerContrato',
  setup(__props) {

  const route = useRoute();

  var controle = reactive({
    contratoId: 0,
    model: {} as service.Contrato,


    status: "",
    erro: "",
  })

  onMounted(async ()=>{
    pesquisar();
  })

  async function pesquisar() {

    console.log("busca contrato", controle.contratoId);
    if (route.params.contratoId) {
      controle.contratoId = parseInt(route.params.contratoId as string);
    }
  
    service.obterDados()
    .then(r=> {
      console.log(r);
      controle.model = r.contratos.find(c=> c.contratoId == controle.contratoId) as service.Contrato;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  } 


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(imgLogin),
          alt: "Logo",
          class: "img-fluid img-logo mb-3"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, "Contrato: " + _toDisplayString(_unref(controle).model.plano?.nome), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_unref(controle).erro == '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(_unref(controle).status), 1))
          : _createCommentVNode("", true),
        (_unref(controle).erro != '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(_unref(controle).erro), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "mb-4 pb-4 bg-white",
      innerHTML: _unref(controle).model.texto
    }, null, 8, _hoisted_10),
    _createElementVNode("nav", _hoisted_11, [
      _createElementVNode("form", _hoisted_12, [
        _createVNode(_component_RouterLink, {
          class: "btn btn-primary btn-sm me-2",
          type: "button",
          to: { name: 'PainelCliente' }
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Voltar", -1)
          ]))]),
          _: 1
        }),
        (_unref(controle).model.dataAssinatura == null)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              class: "btn btn-warning btn-sm",
              type: "button",
              to: { name: 'PainelClienteAssinarContrato', params: { contratoId: _unref(controle).contratoId } }
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Assinar", -1)
              ]))]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})